import { createObservable } from "./v1/create-observable";
export function defineFeatureappService(options, additionalOptions) {
    return {
        id: "featureapp-service",
        create: () => ({
            "1.5.0": (consumerId, consumerName) => {
                const accessListener = additionalOptions
                    ? (featureApp) => {
                        additionalOptions.onAccess(consumerId, consumerName, featureApp);
                    }
                    : undefined;
                const featureAppConfigurations = createObservable(options, accessListener);
                return {
                    featureService: {
                        featureAppConfigurations
                    }
                };
            }
        })
    };
}
